import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export function EmailCapture({ compact, postAudit }) {
  const [email, setEmail] = useState("");
  const [zip, setZip] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/email-signup", { email, zip });
      setDone(true);
      toast.success(data.message || "You're on the list.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const heading = postAudit ? "WANT THE NEXT ONE?" : "DON'T OVERPAY. GET THE RECEIPT.";
  const sub = "Free stuff. Secondhand finds. Better alternatives. Deals. Benefits. Refunds. Local finds. Things worth knowing before you spend money.";

  return (
    <section className={compact ? "" : "border-t hairline"}>
      <div className={compact ? "" : "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20"}>
        <div className="eyebrow mb-4">THE CHEAPER WAY LIST</div>
        <h2 className="font-display text-4xl md:text-6xl leading-[0.95] mb-4">{heading}</h2>
        <p className="font-serif text-lg text-stone-300 max-w-xl mb-8 leading-relaxed">{sub}</p>
        {done ? (
          <div data-testid="email-success" className="font-display text-2xl text-[#5FB878]">You're on the list. ✓</div>
        ) : (
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-2xl">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="YOUR EMAIL"
              data-testid="email-input"
              className="flex-1 bg-transparent border hairline px-5 py-4 text-stone-100 placeholder:text-stone-600 focus:border-[#EF3340] outline-none font-label text-sm" />
            <input value={zip} onChange={(e) => setZip(e.target.value)} placeholder="ZIP (optional)" data-testid="email-zip-input"
              className="w-full sm:w-40 bg-transparent border hairline px-5 py-4 text-stone-100 placeholder:text-stone-600 focus:border-[#EF3340] outline-none font-label text-sm" />
            <button type="submit" disabled={loading} data-testid="email-submit-btn"
              className="font-label text-xs tracking-widest bg-[#EF3340] text-white px-8 py-4 hover:bg-[#cc2a35] transition-colors disabled:opacity-50 whitespace-nowrap">
              {loading ? "…" : postAudit ? "SEND ME THE FINDS →" : "GET THE GOOD STUFF →"}
            </button>
          </form>
        )}
        <p className="font-label text-[10px] tracking-widest text-stone-600 mt-4">FREE · UNSUBSCRIBE ANYTIME</p>
      </div>
    </section>
  );
}
